export default __webpack_public_path__ + "static/media/a4-printer_he.80d428a2.png";